import { Reducer } from 'redux'
import { IGeneralState } from 'store/states/general.state'
import * as fromActions from '../actions/general.action'

export const initialState: IGeneralState = {
  permissions: {
    attestationsEnabled: false,
    dc4Enabled: false,
    courseEnrolCreatedNotificationEnabled: false,
  },
  settings: {},
  loading: false,
  settingsLoaded: false,
  defaultLmsProfiles: [],
  integrations: {
    list: [],
    loading: false,
  },
}

export const reducer: Reducer<IGeneralState, fromActions.ReducerActions> = (
  state = initialState,
  action
): IGeneralState => {
  switch (action.type) {
    case fromActions.GENERAL_CONFIG_GET:
    case fromActions.GENERAL_CONFIG_UPDATE:
      return {
        ...state,
        loading: true,
        settingsLoaded: false,
      }
    case fromActions.GENERAL_CONFIG_UPDATE_SUCCESS:
    case fromActions.GENERAL_CONFIG_GET_SUCCESS: {
      const {
        foldersSettings,
        attestationsEnabled = false,
        dc4Enabled = false,
        courseEnrolCreatedNotificationEnabled = false,
      } = action.payload

      return {
        ...state,
        permissions: {
          attestationsEnabled,
          dc4Enabled,
          courseEnrolCreatedNotificationEnabled,
        },
        settings: {
          folders: {
            ...foldersSettings,
          },
        },
        loading: false,
        settingsLoaded: true,
      }
    }
    case fromActions.GENERAL_CONFIG_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case fromActions.GENERAL_LMS_PROFILES_DEFAULT_SUCCESS:
      return {
        ...state,
        defaultLmsProfiles: action.payload,
      }
    case fromActions.GENERAL_INTEGRATIONS_LIST: {
      return {
        ...state,
        integrations: {
          ...state.integrations,
          loading: true,
        },
      }
    }
    case fromActions.GENERAL_INTEGRATIONS_SET_LOADING: {
      return {
        ...state,
        integrations: {
          ...state.integrations,
          loading: action.payload,
        },
      }
    }
    case fromActions.GENERAL_INTEGRATIONS_LIST_SUCCESS: {
      const list = action.payload
      return {
        ...state,
        integrations: {
          ...state.integrations,
          list,
          loading: false,
        },
      }
    }
    default:
      return state
  }
}
